import { type ReactElement } from 'react'

interface Props {
  message?: string
}

export function ErrorBanner ({ message }: Props): ReactElement | null {
  if (message == null || message === '') return null
  return (
    <div
      style={{
        background: 'var(--bp-critical-pale)',
        border: '1px solid var(--bp-critical-border)',
        borderRadius: 8,
        padding: '12px 16px',
        marginBottom: 16
      }}
    >
      <span style={{ color: 'var(--bp-critical)', fontSize: 13 }}>{message}</span>
    </div>
  )
}
